import { useAuth } from "@/context/AuthContext";
import { fileUrl } from "@/lib/api";
import { AUTH_BG } from "@/lib/images";
import ElmMark, { ElmGlyph } from "@/components/ElmMark";

export function BrandMark({ className = "", light = false }) {
  const { brand } = useAuth();
  const logo = brand.branding?.logo_url;
  if (logo) return <img src={fileUrl(logo)} alt={brand.name} className={`h-10 max-w-[180px] object-contain ${className}`} data-testid="brand-logo" />;
  return (
    <span className={`flex items-center gap-2 section-title leading-none ${className}`} data-testid="brand-name">
      {brand.platform && <ElmGlyph className="h-7 w-7" />}{brand.name}
    </span>
  );
}

export default function AuthLayout({ eyebrow, title, children }) {
  const { brand } = useAuth();
  const hero = brand.branding?.hero_image_url ? fileUrl(brand.branding.hero_image_url) : AUTH_BG;
  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="grain relative hidden overflow-hidden lg:block">
        <img src={hero} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
        <div className="absolute bottom-12 left-12 max-w-md text-white">
          <p className="text-xs uppercase tracking-[0.3em] text-white/70" data-testid="auth-brand-name">{brand.platform ? "Elevated Living Management" : brand.name}</p>
          <p className="mt-3 font-serif text-5xl leading-[1.05]">{brand.platform ? "Run your builds from one place." : brand.branding.tagline}</p>
          {brand.platform && <p className="mt-4 text-sm text-white/80">Schedules, crews, trades, money and a client window into every job, branded as your company.</p>}
        </div>
      </div>
      <div className="relative flex flex-col justify-between overflow-hidden px-6 py-12 sm:px-16">
        <div className="rise my-auto w-full max-w-sm">
          <BrandMark className="text-primary" />
          <p className="eyebrow mb-3 mt-12">{eyebrow}</p>
          <h1 className="mb-8 font-serif text-4xl leading-tight sm:text-5xl">{title}</h1>
          {children}
        </div>
        <div className="mt-10"><ElmMark /></div>
      </div>
    </div>
  );
}
